import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MDBSpinner } from 'mdb-react-ui-kit';
import {
    verifyEmailStatus, getPricingPlansById,
    getUserByEmail, getEnvFileData, getRoleAccess,
    getUserByStaffId,
    sendOtptoVerify,
    verifyEmailOtpForSignup,
    endBussinessSession
} from "../services/apiServices";
import { browserName, browserVersion } from "react-device-detect";
import axios from "axios";
import { logEvent } from "../services/apiServices.js";
import logImg from "./../components/images/Easy-MembrLogo.png";

import { Link } from "react-router-dom";
import { CardBody, Col, Row } from "reactstrap";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBIcon } from "mdb-react-ui-kit";
import logBg from "./../components/images/loginBg.png";
import { trackButtonClick } from "../utils/analytics";
import { useAccess } from "../context/AccessContext";

export function VerifyPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // ── Flow 1 params (signup OTP flow)
    const email = searchParams.get('email');
    const business = searchParams.get('business');
    const planId = searchParams.get('id');


    const gymId = searchParams.get('gymId');
    const staffId = searchParams.get('staffId');

    const decodedEmail = email ? decodeURIComponent(email) : null;
    const decodedBusiness = business ? decodeURIComponent(business) : null;
    const decodedGymId = gymId ? decodeURIComponent(gymId) : null;
    const decodedStaffId = staffId ? decodeURIComponent(staffId) : null;




    console.log("dataaa", gymId, decodedStaffId)
    // ── Flow 2 param (email link flow)
    const mailId = searchParams.get('mailid');

    // ── Which flow are we in?
    const isLinkFlow = Boolean(mailId);

    console.log("isLinkFlow", isLinkFlow)

    // ── Shared state
    const [userData, setUserData] = useState(null);
    console.log("userData", userData)

    const [token, setToken] = useState("");

    // ── Flow 1 state (OTP)
    const [emailOtpDigits, setEmailOtpDigits] = useState(["", "", "", "", "", ""]);
    const [emailSentOtp, setEmailSentOtp] = useState("");
    const [emailError, setEmailError] = useState("");
    const [emailVerifyLoading, setEmailVerifyLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const otpRefs = useRef([]);

    // ── Flow 2 state (auto-verify)
    const [linkStatus, setLinkStatus] = useState("verifying");



    const { fetchAccess, classFetchAccess } = useAccess();

    // ─── shared helpers ──────────────────────────────────────────────────────

    const fetchEnvData = async () => {
        try {
            const response = await getEnvFileData();
            if (response.ok) {
                const data = await response.json();
                if (data?.length > 0)
                    localStorage.setItem("frontEndEnvData", JSON.stringify(data[0]));
            }
        } catch (e) { console.error("fetchEnvData error:", e); }
    };


    // const fetchAccessInfo = async (userData) => {
    //     try {
    //         console.log("Fetching access for userData:", userData);
    //         if (!userData?.rolevalues) {
    //             console.log("No rolevalues found");
    //             return null;
    //         }

    //         const response = await getRoleAccess("easymembr", userData?.rolevalues);
    //         console.log("Accesresponse:", response);

    //         if (!response || response === "false") {
    //             console.log("No access response");
    //             return null;
    //         }

    //         const recinfo = await response.json();
    //         console.log("Access recinfo:", recinfo);

    //         if (recinfo?.access) {
    //             localStorage.setItem("accessInfo", JSON.stringify(recinfo.access));
    //             return recinfo.access;
    //         }
    //         return null;
    //     } catch (err) {
    //         console.error("fetchAccessInfo error:", err);
    //         return null;
    //     }
    // };





    async function fetchAccessInfo(userInfo) {
        try {
            if (!userInfo?.rolevalues) {
                return null;
            }

            const response = await getRoleAccess("easymembr", userInfo.rolevalues);
            if (!response || response === "false") {
                return null;
            }

            const recinfo = await response.json();
            if (recinfo) {
                console.log(recinfo, 'recinfo');
                // Store access info in localStorage
                if (recinfo?.access) {
                    localStorage.setItem("accessInfo", JSON.stringify(recinfo.access));
                }
                return recinfo?.access;
            }
            return null;
        } catch (err) {
            console.error("Error fetching access:", err);
            return null;
        }
    }


    const fetchAndStorePlanInfo = async (gymid) => {
        try {
            const response = await getPricingPlansById(gymid);
            const recinfo = await response.json();
            if (recinfo) {
                localStorage.setItem("planInfo", JSON.stringify(recinfo));
                return recinfo;
            }
        } catch (error) { console.error("fetchAndStorePlanInfo error:", error); }
        return null;
    };

    const logVerificationEvent = async (userInfo, gymid) => {
        try {
            let ip = localStorage.getItem("ipaddress") || "--";
            if (!ip || ip === "--") {
                try {
                    const raw = localStorage.getItem("frontEndEnvData");
                    const url = raw
                        ? JSON.parse(raw)?.reactappipaddressurl
                        : "https://api.ipify.org?format=json";
                    const res = await axios.get(url);
                    ip = res.data.ip;
                    localStorage.setItem('ipaddress', ip);
                } catch (e) { console.error("IP fetch error:", e); }
            }
            const browserinfo = `${browserName}-${browserVersion}.0.0`;
            await logEvent(
                { Eventtype: "email_verification", username1: userInfo.email, ip, flag: "Email Verification Successfull", browserinfo, gymid },
                gymid
            );
        } catch (error) { console.error("logVerificationEvent error:", error); }
    };

    // Builds the exact localStorage shape the dashboard expects
    const buildUserInfo = (user, fallbackName = "") => ({
        _id: user._id,
        name: user.name || fallbackName,
        username: user.email,
        fname: user.fname || fallbackName,
        lname: user.lname || "",
        gymid: user.gymid,
        gymname: user.gymname || fallbackName,
        number: user.number || "",
        email: user.email,
        role: user.role || "admin",
        rolevalues: user.rolevalues || [1],
        email_id: user.email_id || "",
        gymlogoUrl: user.gymlogoUrl || "",
        isemailverifed: "1",
        dateFormat: user.dateFormat || "MM/DD/YYYY",
        planname: user.planname || "",
    });


    // ─── FLOW 2: email link — auto-verify on mount ───────────────────────────
    useEffect(() => {
        if (!isLinkFlow) return;

        const autoVerify = async () => {
            try {
                console.log("Starting auto-verify for mailId:", mailId);
                if (!mailId) return
                const res = await getUserByStaffId(mailId);
                if (!res) {
                    console.error("No response from API");
                    return;
                }

                const data = await res.json();
                if (!data.success || !data.userInfo || !data.token) {
                    console.error("Invalid response data:", data);
                    return;
                }

                // Mark email as verified
                await verifyEmailStatus(data.userInfo.gymid, { isemailverified: true });

                const userInfo = buildUserInfo(data.userInfo, data.userInfo.businessName || data.userInfo.name);

                // Store data immediately
                localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
                localStorage.setItem("token", data.token);

                // Fetch all data including access
                await Promise.all([
                    fetchAndStorePlanInfo(data.userInfo.gymid),
                    fetchEnvData(),
                    fetchAccessInfo(userInfo),
                    logVerificationEvent(userInfo, data.userInfo.gymid)
                ]);

                // CRITICAL: Update AccessContext
                await fetchAccess();
                classFetchAccess();

                setLinkStatus("success");

                // Navigate after context is updated
                setTimeout(() => {
                    navigate("/dashboard", { replace: true });
                }, 500);

            } catch (e) {
                console.error("autoVerify error:", e);
            }
        };

        autoVerify();
    }, [mailId, navigate]);



    // ─── FLOW 1: on mount — fetch user + send OTP (only once) ────────────────────────────


    useEffect(() => {
        console.log("getUserByEmail", isLinkFlow, decodedGymId, decodedStaffId);

        if (isLinkFlow || !decodedGymId || !decodedStaffId) return;

        // Flag to prevent multiple sends in same session
        let isOtpSent = false;

        const otpSentKey = `otp_sent_${decodedGymId}_${decodedStaffId}`;
        const hasOtpBeenSent = sessionStorage.getItem(otpSentKey);

        const init = async () => {
            try {
                console.log("Starting user fetch for gymId:", decodedGymId, "mid:", decodedStaffId);

                const updates = {
                    gymId: decodedGymId,
                    mid: decodedStaffId
                };

                const res = await getUserByEmail(decodedStaffId, updates);

                if (!res) {
                    console.error("No response from getUserByEmail");
                    return;
                }

                const data = await res.json();
                const user = data?.userInfo;

                if (!user) {
                    console.error("No user info in response");
                    return;
                }

                setUserData(user);
                setToken(data?.token);

                console.log("User found:", user.email);

                if (user?.gymid) {
                    await fetchAndStorePlanInfo(user.gymid);
                }

                // Only send OTP if not already sent and not sent in this session
                if (!hasOtpBeenSent && !isOtpSent) {
                    try {
                        console.log("Sending OTP to:", user?.email || decodedEmail);

                        const payload = {
                            email: user?.email || decodedEmail,
                            name: user?.fname || user?.name || decodedBusiness || "User",
                            userid: user?._id || decodedStaffId
                        };

                        console.log("Auto OTP Payload:", payload);

                        const resOtp = await sendOtptoVerify(payload);

                        // Check if response exists
                        if (!resOtp) {
                            console.error("No response from sendOtptoVerify");
                            setEmailError("Failed to send verification code. Please click Resend.");
                            return;
                        }

                        const otpData = await resOtp.json();
                        console.log("OTP Response:", otpData);

                        if (otpData.success) {
                            sessionStorage.setItem(otpSentKey, 'true');
                            isOtpSent = true;
                            console.log("OTP sent successfully");

                            // Optional: Show success message
                            setSuccessMessage("Verification code sent to your email!");
                            setTimeout(() => setSuccessMessage(""), 3000);
                        } else {
                            setEmailError(otpData.message || "Failed to send verification code. Please click Resend.");
                        }
                    } catch (e) {
                        console.error("sendOtptoVerify error:", e);
                        setEmailError("Failed to send verification code. Please click Resend.");
                    }
                } else {
                    console.log("OTP already sent, skipping auto-send");
                }

            } catch (e) {
                console.error("getUser error:", e);
                setEmailError("Failed to fetch user information.");
            }
        };

        init();
    }, [decodedGymId, decodedStaffId, isLinkFlow]);










    // ─── FLOW 1: verify button ───────────────────────────────────────────────

    const verifyEmailOtp = async () => {
        const enteredOTP = emailOtpDigits.join("");

        if (enteredOTP.length !== 6) {
            setEmailError("Please enter the full 6-digit code.");
            return;
        }

        setEmailVerifyLoading(true);
        setEmailError("");

        try {
            const userEmail = decodeURIComponent(email || "");
            const userName = decodeURIComponent(business || "");

            // Step 1: Verify OTP with backend
            const verifyResponse = await verifyEmailOtpForSignup({
                email: userEmail,
                otp: enteredOTP
            });

            const verifyData = verifyResponse.data || await verifyResponse.json();

            if (!verifyData.success) {
                setEmailError(verifyData.message);
                setEmailVerifyLoading(false);
                return;
            }

            // Step 2: Update email verification status
            const saveResponse = await verifyEmailStatus(userData.gymid, { isemailverified: true });

            if (!saveResponse || !saveResponse.ok) {
                setEmailError("Failed to update email verified status. Please try again.");
                setEmailVerifyLoading(false);
                return;
            }

            // Step 3: Build user info
            const userInfo = buildUserInfo(userData, userName);
            userInfo.email = userEmail;
            userInfo.username = userEmail;

            // Step 4: Store user data and token
            localStorage.setItem("loggedUserInfo", JSON.stringify(userInfo));
            localStorage.setItem("token", token);

            // Step 5: Fetch and store access data
            const accessData = await fetchAccessInfo(userData);

            // Step 6: Remove OTP session flag
            const otpSentKey = `otp_sent_${userEmail}`;
            sessionStorage.removeItem(otpSentKey);

            // Step 7: Fetch remaining data in parallel
            await Promise.all([
                fetchAndStorePlanInfo(userData.gymid),
                fetchEnvData(),
                logVerificationEvent(userInfo, userData.gymid)
            ]);

            // Step 8: CRITICAL - Update AccessContext (same as Login does)
            await fetchAccess();  // This updates the roleAccess in context
            classFetchAccess();   // This updates the classRoleAccess

            // Step 9: Verify all data is stored
            const verifyUser = localStorage.getItem("loggedUserInfo");
            const verifyAccess = localStorage.getItem("accessInfo");

            console.log("Verification - User:", !!verifyUser);
            console.log("Verification - Access:", !!verifyAccess);

            // if (!verifyUser || !verifyAccess) {
            //     console.error("Missing required data in localStorage");
            //     setEmailError("Setup incomplete. Please try again.");
            //     setEmailVerifyLoading(false);
            //     return;
            // }

            setSuccessMessage("Email verified successfully!");

            setTimeout(() => {
                navigate("/dashboard", { replace: true });
            }, 500);

        } catch (error) {
            console.error("verifyEmailOtp error:", error);
            setEmailError("Something went wrong. Please try again.");
            setEmailVerifyLoading(false);
        }
    };


    // ─── FLOW 1: resend OTP ──────────────────────────────────────────────────
    const handleResendOtp = async () => {
        setResendLoading(true);
        setEmailError("");

        try {
            const userEmail = decodeURIComponent(email || "");
            const userName = decodeURIComponent(business || "");

            const response = await sendOtptoVerify({
                email: userEmail,
                name: userName,
                userid: userData?._id
            });

            const resData = await response.json();

            if (resData.success) {
                // Clear OTP inputs
                setEmailOtpDigits(["", "", "", "", "", ""]);
                // Show success message
                setEmailError("OTP resent successfully! Please check your email.");

                // Update session storage to prevent auto-resend
                const otpSentKey = `otp_sent_${userEmail}`;
                sessionStorage.setItem(otpSentKey, 'true');

                // Focus on first OTP input after a short delay
                setTimeout(() => {
                    otpRefs.current[0]?.focus();
                }, 100);

                // Clear the success message after 3 seconds
                setTimeout(() => {
                    setEmailError("");
                }, 3000);
            } else {
                setEmailError(resData.message || "Failed to resend OTP. Please try again.");
                // Clear error message after 3 seconds
                setTimeout(() => {
                    setEmailError("");
                }, 3000);
            }
        } catch (error) {
            console.error("Resend OTP error:", error);
            setEmailError("Something went wrong. Please try again.");
            setTimeout(() => {
                setEmailError("");
            }, 3000);
        } finally {
            setResendLoading(false);
        }
    };
    // ─── FLOW 1: OTP input handlers ──────────────────────────────────────────

    const handleOtpChange = (index, value) => {
        const val = value.replace(/[^0-9]/g, "");
        const newOtp = [...emailOtpDigits];
        newOtp[index] = val;
        setEmailOtpDigits(newOtp);
        if (emailError) setEmailError("");
        if (val && index < 5 && otpRefs.current[index + 1])
            otpRefs.current[index + 1].focus();
    };

    const handleOtpKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !emailOtpDigits[index] && index > 0 && otpRefs.current[index - 1])
            otpRefs.current[index - 1].focus();
    };

    // ─── RENDER: FLOW 2 (email link auto-verify) ─────────────────────────────

    if (isLinkFlow) {
        return (
            <>
                <style>{sharedStyles}</style>
                <div className="verify-page-wrapper">
                    <div className="verify-topbar" style={{ background: '#f0f4f8', border: '0' }}>
                        <img src={logImg} className="gymlogo1 m-0 " alt="" style={{ width: '250px' }} />
                    </div>

                    <div className="verify-center">
                        <div className="verify-card">
                            {linkStatus === "verifying" && (
                                <>
                                    <div className="verify-icon-circle" style={{ background: '#dbeafe' }}>
                                        <MDBSpinner style={{ width: 28, height: 28, color: '#1d4ed8' }} />
                                    </div>
                                    <div className="verify-title">Verifying your email…</div>
                                    <div className="verify-subtitle">Please wait a moment.</div>
                                </>
                            )}

                            {linkStatus === "success" && (
                                <>
                                    <div className="verify-icon-circle">
                                        <svg fill="none" stroke="#16a34a" strokeWidth="2.5" viewBox="0 0 24 24" style={{ width: 28, height: 28 }}>
                                            <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div className="verify-title">Email Verified Successfully!</div>
                                    <div className="verify-subtitle">Redirecting to your dashboard…</div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // ─── RENDER: FLOW 1 (OTP signup verify) ──────────────────────────────────


    async function handleClick() {
        try {
            // logOutUser(JSON.parse(localStorage.getItem("loggedUserInfo"))._id);
            let ip = localStorage.getItem("ipaddress");
            let browserinfo = browserName + "-" + browserVersion + ".0.0";
            let flag = "Logout Successfull";
            let Eventtype = "login";
            let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
            let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";
            let staffid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo"))._id : "";
            await trackButtonClick("LeftPane", "Staff_Logout", "staff", {});
            await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
            const date = new Date()
            console.log(date.toISOString());
            const update = {
                staffid: staffid,
                date: date.toISOString()
            }
            await endBussinessSession(staffid, update);
            localStorage.removeItem("transaction_filter");
            localStorage.removeItem("loggedUserInfo");
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("ipaddress");
            window.location.href = "/login";
            localStorage.removeItem("planInfo");
            localStorage.removeItem("frontEndEnvData");
            sessionStorage.clear();

            //this.context.router.transitionTo('/login');
            //return;
        } catch (e) {
            console.log(e);
        }
    }


    return (
        <React.Fragment>
            <div className="back-to-home">
                <Link
                    onClick={handleClick}
                >
                    <MDBBtn>
                        <MDBIcon fas icon="arrow-left" />
                    </MDBBtn>
                </Link>
            </div>
            <section className="cover-user bg-white">
                <div className="container-fluid px-0">
                    <Row className="g-0 position-relative">
                        <Col lg={4} className="cover-my-30 ">
                            <div className="cover-user-img d-flex">
                                <Row className="w-100">
                                    <div className="col-12">
                                        <div className="d-flex flex-column auth-hero">
                                            <div className="my-md-5 text-center">
                                                {/* <Link to="/" >
                                                    <img src={logImg} className="gymlogo1 mt-md-5" alt="" />
                                                </Link> */}
                                                <img src={logImg} className="gymlogo1 mt-md-5" alt="" />
                                            </div>
                                            <MDBCard className="border border-success w-100">
                                                <MDBCardBody>
                                                    <MDBCardTitle className="text-center">Verify Your Email</MDBCardTitle>
                                                    <div className="title-heading mt-0 my-lg-auto">
                                                        <div
                                                            className="login-page border-0 p-0"
                                                            style={{ zIndex: 1 }}
                                                        >
                                                            <CardBody className="p-0">
                                                                <div className="text-center mb-4">
                                                                    <div className="verify-icon-circle" style={{
                                                                        width: '64px',
                                                                        height: '64px',
                                                                        background: '#dcfce7',
                                                                        borderRadius: '50%',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        margin: '0 auto 24px'
                                                                    }}>
                                                                        <MDBIcon fas icon="envelope" style={{ fontSize: '28px', color: '#16a34a' }} />
                                                                    </div>
                                                                    <p className="text-muted mb-1">We've sent a 6-digit verification code to</p>
                                                                    <p className="fw-bold mb-3">{decodeURIComponent(email || "")}</p>
                                                                </div>

                                                                <form onSubmit={(e) => { e.preventDefault(); verifyEmailOtp(); }}>
                                                                    <div style={{ color: "red" }} className="mb-2">{emailError && !emailError.toLowerCase().includes('resent') && emailError}</div>
                                                                    {emailError && emailError.toLowerCase().includes('resent') && (
                                                                        <div style={{ color: "#16a34a" }} className="mb-2">{emailError}</div>
                                                                    )}
                                                                    {successMessage && (
                                                                        <div style={{ color: "#16a34a" }} className="mb-2">{successMessage}</div>
                                                                    )}

                                                                    <div className="mb-4">
                                                                        <label className="form-label text-center d-block">
                                                                            Enter Verification Code
                                                                        </label>
                                                                        <div className="d-flex justify-content-center gap-2">
                                                                            {emailOtpDigits.map((digit, index) => (
                                                                                <input
                                                                                    key={index}
                                                                                    ref={(el) => (otpRefs.current[index] = el)}
                                                                                    type="text"
                                                                                    inputMode="numeric"
                                                                                    maxLength={1}
                                                                                    className="form-control text-center"
                                                                                    style={{ fontSize: '22px', fontWeight: 'bold' }}
                                                                                    value={digit}
                                                                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                                                                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                                                                    disabled={emailVerifyLoading}
                                                                                    required
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <div className="d-grid">
                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-primary"
                                                                                disabled={emailVerifyLoading}
                                                                            >
                                                                                {emailVerifyLoading ? (
                                                                                    <>
                                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                                        Verifying...
                                                                                    </>
                                                                                ) : (
                                                                                    "Verify Email"
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    <div className="text-center mt-3">
                                                                        <p className="mb-0">
                                                                            Didn't receive the code?{" "}
                                                                            <span
                                                                                onClick={handleResendOtp}
                                                                                style={{ cursor: 'pointer', color: '#22c55e', fontWeight: '600' }}
                                                                                className="text-primary"
                                                                            >
                                                                                {resendLoading ? "Sending..." : "Resend Code"}
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </form>
                                                            </CardBody>
                                                        </div>
                                                    </div>
                                                </MDBCardBody>
                                            </MDBCard>
                                            <div className="footer mb-md-5 text-center">
                                                <p className="mt-2 text-muted">
                                                    © {new Date().getFullYear()} EasyMembr.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </div>
                        </Col>
                        <div
                            className="col-lg-8 padding-less img"
                            style={{ backgroundImage: `url(${logBg})` }}
                            data-jarallax='{"speed": 0.5}'
                        >
                            <div className="greenoverlay"></div>
                        </div>
                    </Row>
                </div>
            </section>
        </React.Fragment>
    );
}

// ─── styles (shared by both flows) ──────────────────────────────────────────

const sharedStyles = `
    .verify-page-wrapper { min-height:100vh; background-color:#f0f4f8; display:flex; flex-direction:column; }
    .verify-topbar { background:#fff; border-bottom:1px solid #e5e7eb; padding:12px 24px; display:flex; align-items:center; }
    .verify-back-link { display:inline-flex; align-items:center; gap:6px; color:#374151; font-size:14px; font-weight:500; text-decoration:none; margin:24px 32px; cursor:pointer; width:fit-content; }
    .verify-back-link:hover { color:#111; }
    .verify-center { flex:1; display:flex; align-items:center; justify-content:center; padding:0 16px 40px; }
    .verify-card { background:#fff; border-radius:16px; box-shadow:0 4px 24px rgba(0,0,0,0.08); padding:48px 40px 40px; width:100%; max-width:460px; text-align:center; }
    .verify-icon-circle { width:64px; height:64px; background:#dcfce7; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 24px; }
    .verify-icon-circle svg { width:28px; height:28px; color:#16a34a; }
    .verify-title { font-size:22px; font-weight:700; color:#111827; margin-bottom:10px; }
    .verify-subtitle { font-size:14px; color:#6b7280; margin-bottom:4px; }
    .verify-email { font-size:15px; font-weight:600; color:#111827; margin-bottom:28px; }
    .verify-code-label { font-size:13px; font-weight:600; color:#374151; margin-bottom:12px; }
    .otp-inputs { display:flex; justify-content:center; gap:10px; margin-bottom:28px; }
    .otp-box { width:48px; height:52px; border:1.5px solid #e5e7eb; border-radius:10px; font-size:22px; font-weight:700; color:#111827; text-align:center; background:#f9fafb; outline:none; transition:border-color 0.2s,box-shadow 0.2s; }
    .otp-box:focus { border-color:#22c55e; box-shadow:0 0 0 3px rgba(34,197,94,0.15); background:#fff; }
    .verify-btn { width:100%; padding:14px; background:#22c55e; color:#fff; font-size:15px; font-weight:600; border:none; border-radius:10px; cursor:pointer; transition:background 0.2s; display:flex; align-items:center; justify-content:center; gap:8px; }
    .verify-btn:hover:not(:disabled) { background:#16a34a; }
    .verify-btn:disabled { opacity:0.7; cursor:not-allowed; }
    .verify-resend { font-size:13px; color:#6b7280; margin-top:20px; }
    .verify-resend-link { color:#22c55e; font-weight:600; cursor:pointer; }
    .verify-resend-link:hover { color:#16a34a; text-decoration:underline; }
    .verify-error { margin-top:14px; font-size:13px; color:#dc2626; font-weight:500; }
    .verify-success { margin-top:14px; font-size:13px; color:#16a34a; font-weight:500; }
`;